"use client";

import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import classNames from "components/ui/classNames";

import type { ComponentPropsWithoutRef, ElementRef } from "react";
import { forwardRef } from "react";

const HoverCard = HoverCardPrimitive.Root;
const HoverCardTrigger = HoverCardPrimitive.Trigger;
const HoverCardPortal = HoverCardPrimitive.Portal;
const HoverCardArrow = HoverCardPrimitive.Arrow;

const HoverCardContent = forwardRef<
  ElementRef<typeof HoverCardPrimitive.Content>,
  ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Content
    ref={ref}
    align={align}
    sideOffset={sideOffset}
    className={classNames(
      "z-50 w-64 rounded-xl border border-zinc-200 bg-white p-4 font-aeonik font-normal shadow-lg outline-none animate-in zoom-in-95",
      "dark:bg-slate-900 dark:border-slate-950",
      className,
    )}
    {...props}
  />
));

HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardPortal, HoverCardContent, HoverCardArrow };
